module.exports = __webpack_public_path__ + "img/linkedin_gray.c6613e66.svg";